import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import { ColumnsI } from "../../../components/Table/TableProps";
import { toRupiah } from "../../../utils/common";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow_right.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trash.svg";
import { SetModalConfigType } from "./hooks/Provider";
import { IGetTrxCodeData } from "../../../services/trxCodeService";
import Status, { StatusEnums } from "../../../components/Status";
import { CommonTrxTypes, EntryType } from "../../../enums/common";

interface ColumnsPropsI {
  setModalConfig: SetModalConfigType;
}

const { danger, primary } = BlueBirdTheme.colors;

const columns: ({ setModalConfig }: ColumnsPropsI) => ColumnsI = ({ setModalConfig }) => {
  const renderEntryType = (item: EntryType) => {
    const status = {
      S: StatusEnums.WARNING,
      H: StatusEnums.PRIMARY,
      X: StatusEnums.SUCCESS,
    }[item] || undefined;
    return (
      <Status
        status={status}
        content={CommonTrxTypes.find(
          (type) => type.value === item,
        )?.label}
      />
    );
  };

  const renderActions = (item: any, row: any) => (
    <div style={{ display: "flex", gap: 8 }}>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={primary[300]}
        onClick={() => setModalConfig({ type: "UPDATE", row: row as IGetTrxCodeData })}
      >
        <EditIcon width={16} height={16} />
      </Button>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={danger[400]}
        onClick={() => setModalConfig({ type: "DELETE", row: row as IGetTrxCodeData })}
      >
        <TrashIcon width={16} height={16} />
      </Button>
    </div>
  );
  return [
    {
      title: "Kode transaksi",
      dataIndex: "trx_code",
      key: "trx_code",
      sort: true,
      width: "150px",
    },
    {
      title: "Akun GL",
      dataIndex: "gnlldr",
      key: "gnlldr",
      sort: true,
      width: "150px",
    },
    {
      title: "Deskripsi",
      dataIndex: "trx_desc",
      key: "trx_desc",
      sort: true,
      width: "300px",
    },
    {
      title: "Detail",
      dataIndex: "sap_bktxt",
      key: "sap_bktxt",
      sort: true,
      width: "150px",
    },
    {
      title: "Range code",
      dataIndex: "range_code",
      key: "range_code",
      sort: true,
      width: "150px",
    },
    {
      title: "Debit/kredit",
      dataIndex: "sap_shkzg",
      key: "sap_shkzg",
      sort: true,
      width: "150px",
      render: renderEntryType,
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      width: "108px",
      sticky: "right",
      render: renderActions,
    },
  ];
};

export default columns;
